import { createSlice } from "@reduxjs/toolkit"
import { ErrorType } from "@/shared/types"
import { CommunitySectionsAvailabilityState } from "../types/types"
import { fetchCommunitySectionsAvailability } from "./community-sections-availability-thunk"

const initialState: CommunitySectionsAvailabilityState = {
    status: "idle",
    data: null,
    error: null,
}

const communitySectionsAvailabilitySlice = createSlice({
    name: "communitySectionsAvailability",
    initialState,
    reducers: {},
    extraReducers(builder) {
        builder
            .addCase(fetchCommunitySectionsAvailability.pending, (state) => {
                state.status = "loading"
                state.error = null
            })
            .addCase(fetchCommunitySectionsAvailability.fulfilled, (state, action) => {
                state.status = "loaded"
                state.data = action.payload
                state.error = null
            })
            .addCase(fetchCommunitySectionsAvailability.rejected, (state, action) => {
                state.status = "failed"
                state.error = action.payload as ErrorType
            })
    },
})

export default communitySectionsAvailabilitySlice.reducer
